import React from 'react';
import cx from 'classnames';
import { withRouter } from 'react-router';

import { startsWith, last } from 'lodash';

import { PropTypes } from 'helpers/react';
const { arrayOf, shape, string, element, bool, routerShape } = PropTypes;

import SideBarItem from './SideBarItem';

import topBarStyles from 'shared-components/TopBar/styles/index.scss';
import styles from './styles/index.scss';

@withRouter
export default class SideBar extends React.Component {
  static propTypes = {
    items: arrayOf(
      shape({
        label: string.isRequired,
        link: string.isRequired,
        iconElement: element,
        selected: bool,
        disabled: bool,
      })
    ),
    topBarOffset: bool,
    router: routerShape,
    isCollapsed: bool,
  };
  static defaultProps = {
    items: [],
  };

  handleSelectItem = (path) => {
    if (!path.length) {
      return this.props.router.push('/');
    }

    if (startsWith(last(path), 'http')) {
      // external path
      return window.open(path);
    }

    return this.props.router.push(`/${path.join('/')}`);
  };

  getActivePath = () => {
    const paths = this.props.router.location.pathname.split('/').slice(1);

    return paths[0];
  };

  render() {
    const { isCollapsed } = this.props;

    const containerClasses = cx(styles['sideBar'], {
      [topBarStyles['has-topbar-offset']]: this.props.topBarOffset,
      [styles['sideBar--collapsed']]: isCollapsed,
    });

    return (
      <aside className={containerClasses}>
        <ul
          data-test="sidebar"
          className={styles['sideBar--scrolling-container']}
        >
          {this.props.items.map((item) => (
            <SideBarItem
              {...item}
              key={item.link}
              onSelect={this.handleSelectItem}
              isCollapsed={isCollapsed}
              selected={item.link === this.getActivePath()}
            />
          ))}
        </ul>
      </aside>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/SideBar/index.js